module.exports = __webpack_public_path__ + "img/011.c3896f5b.svg";